//@flow

import type {ProductPricesWrapper} from "./productPricingTypes";
import {getAccountNumber, getUserPostCode, isMaxUser} from "../utils";
import getProductPrices from "./getProductPrices";
import storeProductPrices from "./storeProductPrices";
import {updateDisplayedPrices} from "./updateDisplayedPrices";
import {getLocationPostcode} from "../location-cookie";
import {addUpdateDisplayedPriceEvents} from "./priceEventHandlers";
import {checkDefaultPriceOptionPermission, extractProductTilesToFetchPrices, restoreDataFromBrowser} from "./priceUtils";
import {initCartButtonState} from "../add-to-cart";
import initClearancePrices from "../clearance/clearancePrice";

const initPrices = async (win: WindowProxy) => {
  const { showGstInclusivePreference, displayPricesOptionPreference } = restoreDataFromBrowser(win);
  const accountNumber = isMaxUser(win) ? getAccountNumber(win) : undefined;
  const postCode = getUserPostCode(win) || getLocationPostcode();
  const defaultDisplayPricesOption = checkDefaultPriceOptionPermission(win, displayPricesOptionPreference);
  const defaultShowGstInclusive = showGstInclusivePreference !== undefined && showGstInclusivePreference.toString() ? showGstInclusivePreference : true;
  const defaultPack = '1';
  const defaultQuantity = 1;
  const productCodesWithShowPrice : string[] = extractProductTilesToFetchPrices(win).map(el => el.dataset.productCode);

  if (accountNumber || postCode) {
    const allPrices : ProductPricesWrapper[] = await getProductPrices(productCodesWithShowPrice, accountNumber, postCode);
    storeProductPrices(win, allPrices);
    productCodesWithShowPrice.forEach(productCode => updateDisplayedPrices(win, productCode, defaultQuantity, defaultPack, defaultShowGstInclusive, defaultDisplayPricesOption));
    addUpdateDisplayedPriceEvents(win);
  }

  try {
    initCartButtonState(win);
  } catch (err){
     throw new Error(err);
  }

  initClearancePrices(win);
};

export default initPrices;




// WEBPACK FOOTER //
// ./javascript/product-search-page/product-pricing/index.js